export const GameScore = (props) => 
{

    return "Score: " + props.score.toString();
}

export default GameScore;